<template>
  <div class="links">
    <ul>
      <template v-for="item in links">
        <li
          v-if="item.value !== 'store'"
          :key="item.value"
          class="links-item"
          :class="current === item.value && 'active'"
          @click="handleClick(item.value)"
        >
          {{ item.label }}
        </li>
        <li
          v-if="item.value === 'store' && VERSION_PLATFORM"
          :key="item.value"
          class="links-item"
          :class="current === item.value && 'active'"
          @click="handleClick(item.value)"
        >
          {{ item.label }}
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import store from '@/store'
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    showlinks: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      links: [
        {
          label: this.$t('comps.tabs.157581-0'),
          value: 'goods'
        },
        {
          label: this.$t('comps.tabs.157581-1'),
          value: 'store'
        },
        {
          label: this.$t('comps.tabs.157581-2'),
          value: 'sale_category'
        },
        {
          label: this.$t('comps.tabs.157581-3'),
          value: 'management_category'
        },
        {
          label: this.$t('comps.tabs.157581-4'),
          value: 'tag'
        },
        {
          label: this.$t('comps.tabs.157581-5'),
          value: 'article'
        },
        {
          label: this.$t('comps.tabs.157581-6'),
          value: 'planting'
        },
        {
          label: this.$t('comps.tabs.157581-7'),
          value: 'link'
        },
        {
          label: this.$t('comps.tabs.157581-8'),
          value: 'marketing'
        },
        {
          label: this.$t('comps.tabs.157581-9'),
          value: 'regactivity'
        },
        {
          label: this.$t('comps.tabs.157581-10'),
          value: 'seckill'
        },
        {
          label: this.$t('comps.tabs.157581-11'),
          value: 'custom_page'
        },
        {
          label: this.$t('comps.tabs.157581-12'),
          value: 'liverooms'
        },
        {
          label: this.$t('comps.tabs.157581-13'),
          value: 'other_wxapp'
        }
      ],
      current: ''
    }
  },
  created() {
    if (this.showlinks.length) {
      this.links = this.links.filter((item) => {
        return this.showlinks.includes(item.value)
      })
    }
  },
  mounted() {
    if (this.$route.path === '/store/storemanager/marketingdistributor') {
      let index = this.links.findIndex((n) => n.value == 'custom_page')
      this.links.splice(index, 1)
    }
    this.current = this.type
  },
  methods: {
    handleClick(val) {
      this.$emit('onClick', val)
      this.current = val
    }
  }
}
</script>

<style scoped lang="scss">
.links {
  padding-right: 20px;
  width: 180px;
  border-right: 1px solid #efefef;
  .links-item {
    padding: 10px 0;
    text-align: center;
    cursor: pointer;
    &.active {
      background: #ecf5ff;
      border: 1px solid #b4d9fd;
      border-radius: 60px;
      color: #1f82e0;
    }
  }
}
</style>
